import { computed, effect, Injectable, Signal, signal, untracked } from '@angular/core';
import { Subject } from 'rxjs';
import { MenuChangeEvent } from './api/menuchangeevent';
import { NavigationMenu } from "./api/NavigationMenu";
import { ActivatedRouteSnapshot, Router } from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class MenuService {

    private menuSource = new Subject<MenuChangeEvent>();
    private resetSource = new Subject();

    menuSource$ = this.menuSource.asObservable();
    resetSource$ = this.resetSource.asObservable();

    #mainNavigationItems = signal<any[]>( []);
    mainNavigationItems : Signal<any[]> = this.#mainNavigationItems;

    #subNavigationItems = signal<NavigationMenu[]>( []);
    subNavigationItems : Signal<NavigationMenu[]> = this.#subNavigationItems;

    #activeNavManuIndex = signal<number>(0);
    activeNavManuIndex: Signal<number> = this.#activeNavManuIndex;

    subMenuCount = computed(() => this.#subNavigationItems().length);
    menuCount = computed(() => this.#subNavigationItems().length + 1);

    constructor(private router: Router) {
    }

    onMenuStateChange(event: MenuChangeEvent) {
        this.menuSource.next(event);
    }

    reset() {
        this.resetSource.next(true);
    }

    SetMainNavigationItems(AppNavigation: any[])
    {
        this.#mainNavigationItems.set(AppNavigation);
    }

    AddSubNavigationItems(menu: NavigationMenu)
    {
        this.#subNavigationItems.update((items) => {
            // this is to create a new array, so that the signal will be triggered
            return [
                ...items,
                menu
            ];
        });
        this.#activeNavManuIndex.set(this.#subNavigationItems().length);
    }

    RemoveSubNavigationItems(removedMenu: NavigationMenu)
    {
        this.#subNavigationItems.update((items) => {
            items = items.filter((itemMenu) => itemMenu.name !== removedMenu.name);
            return items;
        });
        this.clampActiveMenuIndex();
    }

    navigateBack()
    {
        this.#activeNavManuIndex.update((index) => {
            return Math.max(index - 1, 0);
        });
    }

    navigateForward()
    {
        this.#activeNavManuIndex.update((index) => {
            return Math.min(index + 1, this.#subNavigationItems().length); // +1 because of the main menu
        });
    }

    navigateToSubMenu(subMenuName: string)
    {
        let index =  this.#subNavigationItems().findIndex((menu) => menu.name === subMenuName);
        if(index === -1)
            return;
        this.#activeNavManuIndex.set(index + 1);
    }

    hasSubMenu(subMenuName: string)
    {
        return this.#subNavigationItems().some((menu) => menu.name === subMenuName);
    }

    private clampActiveMenuIndex()
    {
        if (this.#activeNavManuIndex() >= this.#subNavigationItems().length)
        {
            this.#activeNavManuIndex.set(this.#subNavigationItems().length);
        }
    }
}
